import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6cfd1d12"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mr-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mr-nav-title"
}, "对战战绩", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mr-nav-placeholder"
}, null, -1));
const _hoisted_4 = {
  class: "mr-hero"
};
const _hoisted_5 = {
  class: "mr-hero-meta"
};
const _hoisted_6 = {
  class: "mr-league"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mr-meta-divider"
}, "·", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mr-meta-divider"
}, "·", -1));
const _hoisted_9 = {
  class: "mr-hero-teams"
};
const _hoisted_10 = {
  class: "mr-team"
};
const _hoisted_11 = {
  class: "mr-team-name"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-team-tag home"
}, "主", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mr-score-colon"
}, ":", -1));
const _hoisted_14 = {
  class: "mr-team"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-team-tag away"
}, "客", -1));
const _hoisted_16 = {
  class: "mr-team-name"
};
const _hoisted_17 = {
  class: "mr-hero-time"
};
const _hoisted_18 = {
  class: "mr-season"
};
const _hoisted_19 = {
  class: "mr-season-col"
};
const _hoisted_20 = {
  class: "mr-season-title"
};
const _hoisted_21 = {
  class: "mr-season-item"
};
const _hoisted_22 = {
  class: "mr-season-item"
};
const _hoisted_23 = {
  class: "win"
};
const _hoisted_24 = {
  class: "draw"
};
const _hoisted_25 = {
  class: "loss"
};
const _hoisted_26 = {
  class: "mr-season-item"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-season-divider"
}, null, -1));
const _hoisted_28 = {
  class: "mr-season-col"
};
const _hoisted_29 = {
  class: "mr-season-title"
};
const _hoisted_30 = {
  class: "mr-season-item"
};
const _hoisted_31 = {
  class: "mr-season-item"
};
const _hoisted_32 = {
  class: "win"
};
const _hoisted_33 = {
  class: "draw"
};
const _hoisted_34 = {
  class: "loss"
};
const _hoisted_35 = {
  class: "mr-season-item"
};
const _hoisted_36 = {
  class: "mr-switchBar"
};
const _hoisted_37 = {
  class: "seg mr-tab"
};
const _hoisted_38 = {
  class: "seg-row"
};
const _hoisted_39 = {
  class: "seg"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "seg-row"
};
const _hoisted_42 = {
  class: "seg"
};
const _hoisted_43 = {
  class: "seg"
};
const _hoisted_44 = {
  key: 0,
  class: "mr-error"
};
const _hoisted_45 = {
  key: 1,
  class: "mr-block"
};
const _hoisted_46 = {
  class: "mr-block-title"
};
const _hoisted_47 = {
  class: "mr-block-sub"
};
const _hoisted_48 = {
  key: 0,
  class: "mr-stats"
};
const _hoisted_49 = {
  class: "mr-wdl-nums"
};
const _hoisted_50 = {
  class: "num total"
};
const _hoisted_51 = {
  class: "num win"
};
const _hoisted_52 = {
  class: "num draw"
};
const _hoisted_53 = {
  class: "num loss"
};
const _hoisted_54 = {
  class: "wdl-bar"
};
const _hoisted_55 = {
  key: 1,
  class: "mr-list"
};
const _hoisted_56 = {
  class: "mr-item-meta"
};
const _hoisted_57 = {
  class: "mr-item-date"
};
const _hoisted_58 = {
  class: "mr-item-league"
};
const _hoisted_59 = {
  class: "mr-item-main"
};
const _hoisted_60 = {
  key: 2,
  class: "mr-empty"
};
const _hoisted_61 = {
  key: 2,
  class: "mr-block"
};
const _hoisted_62 = {
  class: "mr-block-title"
};
const _hoisted_63 = {
  class: "mr-block-sub"
};
const _hoisted_64 = {
  key: 0,
  class: "mr-stats"
};
const _hoisted_65 = {
  class: "mr-wdl-nums"
};
const _hoisted_66 = {
  class: "num total"
};
const _hoisted_67 = {
  class: "num win"
};
const _hoisted_68 = {
  class: "num draw"
};
const _hoisted_69 = {
  class: "num loss"
};
const _hoisted_70 = {
  class: "wdl-bar"
};
const _hoisted_71 = {
  key: 1,
  class: "mr-list"
};
const _hoisted_72 = {
  class: "mr-item-meta"
};
const _hoisted_73 = {
  class: "mr-item-date"
};
const _hoisted_74 = {
  class: "mr-item-league"
};
const _hoisted_75 = {
  class: "mr-item-main"
};
const _hoisted_76 = {
  key: 2,
  class: "mr-empty"
};
const _hoisted_77 = {
  key: 3,
  class: "mr-block"
};
const _hoisted_78 = {
  class: "mr-block-title"
};
const _hoisted_79 = {
  class: "mr-block-sub"
};
const _hoisted_80 = {
  key: 0,
  class: "mr-stats"
};
const _hoisted_81 = {
  class: "mr-wdl-nums"
};
const _hoisted_82 = {
  class: "num total"
};
const _hoisted_83 = {
  class: "num win"
};
const _hoisted_84 = {
  class: "num draw"
};
const _hoisted_85 = {
  class: "num loss"
};
const _hoisted_86 = {
  class: "wdl-bar"
};
const _hoisted_87 = {
  key: 1,
  class: "mr-list"
};
const _hoisted_88 = {
  class: "mr-item-meta"
};
const _hoisted_89 = {
  class: "mr-item-date"
};
const _hoisted_90 = {
  class: "mr-item-league"
};
const _hoisted_91 = {
  class: "mr-item-main"
};
const _hoisted_92 = {
  key: 2,
  class: "mr-empty"
};
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { showNotify } from '@nutui/nutui';
const BASE = 'https://webapi.sporttery.cn/gateway/uniform/football/';

// 全局切换参数（值即激活态）

export default {
  __name: 'MatchRecordView',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const matchId = route.params.matchId;
    const TERM_OPTIONS = [6, 10, 20]; // 场次三档；若体彩接口不支持 6，改为 [10,20]
    const termLimits = ref(10); // 6 / 10 / 20
    const homeAwayFlag = ref(0); // 0 不区分主客场 / 1 相同主客场
    const tournamentFlag = ref(0); // 0 全部赛制 / 1 相同赛制
    const activeTab = ref(0); // 0 历史交锋 / 1 主队近况 / 2 客队近况

    // 对阵头部
    const matchHead = ref({});
    const homeGoal = ref('');
    const awayGoal = ref('');
    const colon = ref('');
    const wbsjStatsHome = ref({});
    const wbsjStatsAway = ref({});

    // 历史交锋（往绩）
    const historyMatchList = ref([]);
    const historyStatistics = ref({});

    // 双方近况（getMatchResultV1 一次返回主客两组）
    const homeFormList = ref([]);
    const homeFormStats = ref({});
    const awayFormList = ref([]);
    const awayFormStats = ref({});

    // 加载/错误
    const loading = ref(false);
    const errorMsg = ref('');
    const goBack = () => {
      if (window.history.length > 1) {
        router.back();
      } else {
        router.push('/home');
      }
    };

    /**
     * 对阵头部卡片：队名、比分、赛制、赛季、双方排名与赛季成绩
     */
    const getMatchHeadV1 = async () => {
      try {
        const {
          data
        } = await axios.get(`${BASE}getMatchHeadV1.qry?source=web&sportteryMatchId=${matchId}`);
        matchHead.value = data.value;
        wbsjStatsHome.value = data.value?.wbsjStats?.home || {};
        wbsjStatsAway.value = data.value?.wbsjStats?.away || {};
        const fullCourtGoal = data.value?.fullCourtGoal;
        if (fullCourtGoal != '') {
          homeGoal.value = fullCourtGoal.split(':')[0];
          awayGoal.value = fullCourtGoal.split(':')[1];
          colon.value = ':';
        }
      } catch (e) {
        // 头部卡片加载失败不阻塞战绩数据
      }
    };

    /**
     * 历史交锋往绩
     */
    const getResultHistoryV1 = async () => {
      const {
        data
      } = await axios.get(`${BASE}getResultHistoryV1.qry?sportteryMatchId=${matchId}&termLimits=${termLimits.value}&tournamentFlag=${tournamentFlag.value}&homeAwayFlag=${homeAwayFlag.value}`);
      historyMatchList.value = data.value?.matchList || [];
      historyStatistics.value = data.value?.statistics || {};
    };

    /**
     * 主/客队各自近况（一次返回两边）
     */
    const getMatchResultV1 = async () => {
      const {
        data
      } = await axios.get(`${BASE}getMatchResultV1.qry?sportteryMatchId=${matchId}&termLimits=${termLimits.value}&tournamentFlag=${tournamentFlag.value}&homeAwayFlag=${homeAwayFlag.value}`);
      homeFormList.value = data.value?.home?.matchList || [];
      homeFormStats.value = data.value?.home?.statistics || {};
      awayFormList.value = data.value?.away?.matchList || [];
      awayFormStats.value = data.value?.away?.statistics || {};
    };
    const reloadAll = async () => {
      loading.value = true;
      errorMsg.value = '';
      try {
        await Promise.all([getResultHistoryV1(), getMatchResultV1()]);
      } catch (e) {
        errorMsg.value = '战绩数据加载失败，请稍后重试';
        showNotify.warn('战绩数据加载失败', {
          duration: 2000
        });
      } finally {
        loading.value = false;
      }
    };

    // 三组切换：修改参数后全局重拉（历史交锋 + 双方近况）
    const switchTerm = n => {
      termLimits.value = n;
      reloadAll();
    };
    const switchHomeAway = n => {
      homeAwayFlag.value = n;
      reloadAll();
    };
    const switchTournament = n => {
      tournamentFlag.value = n;
      reloadAll();
    };
    const switchTab = i => {
      activeTab.value = i;
    };

    // ==================== 视角队胜负判定 ====================
    // 某场比赛中 viewTeam（当前视角队）是主队还是客队
    const isViewHome = (m, viewTeam) => {
      return !!m && !!viewTeam && m.homeTeamShortName === viewTeam;
    };
    // 视角队在本场的赛果：win / draw / loss
    const outcomeOf = (m, viewTeam) => {
      if (!m || !viewTeam) return 'draw';
      if (m.winningTeam === 'draw') return 'draw';
      const viewWon = isViewHome(m, viewTeam) && m.winningTeam === 'home' || !isViewHome(m, viewTeam) && m.winningTeam === 'away';
      return viewWon ? 'win' : 'loss';
    };
    const outcomeText = (m, viewTeam) => ({
      win: '胜',
      draw: '平',
      loss: '负'
    })[outcomeOf(m, viewTeam)];
    // 胜平负三色比例条
    const wdlStyle = s => {
      const t = s && s.totalLegCnt || 1;
      return {
        w: Math.min(100, (s && s.winGoalMatchCnt || 0) / t * 100),
        d: Math.min(100, (s && s.drawMatchCnt || 0) / t * 100),
        l: Math.max(0, 100 - Math.min(100, (s && s.winGoalMatchCnt || 0) / t * 100) - Math.min(100, (s && s.drawMatchCnt || 0) / t * 100))
      };
    };
    onMounted(() => {
      getMatchHeadV1();
      reloadAll();
    });
    return (_ctx, _cache) => {
      const _component_var_loading = _resolveComponent("var-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "mr-navbar"
      }, [_createElementVNode("span", {
        class: "mr-back",
        onClick: goBack
      }, "‹ 返回"), _hoisted_2, _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(matchHead.value.tournamentCnShortName), 1), matchHead.value.matchNum ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_7, _createElementVNode("span", null, _toDisplayString(matchHead.value.matchNum), 1)], 64)) : _createCommentVNode("", true), matchHead.value.gameweek != '' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_8, _createElementVNode("span", null, "第" + _toDisplayString(matchHead.value.gameweek) + "轮", 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(matchHead.value.homeTeamShortName), 1), _hoisted_12]), _createElementVNode("div", {
        class: _normalizeClass(["mr-score", {
          playing: colon.value
        }])
      }, [colon.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(homeGoal.value), 1), _hoisted_13, _createTextVNode(_toDisplayString(awayGoal.value), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode("VS")], 64))], 2), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(matchHead.value.awayTeamShortName), 1)])]), _createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(matchHead.value.seasonName) + " " + _toDisplayString(matchHead.value.phaseName) + " ", 1), matchHead.value.matchDateTime ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("· " + _toDisplayString(matchHead.value.matchDateTime), 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(matchHead.value.homeTeamShortName || '主队'), 1), _createElementVNode("div", _hoisted_21, [_createTextVNode("排名 "), _createElementVNode("b", null, _toDisplayString(wbsjStatsHome.value.ranking || '-'), 1)]), _createElementVNode("div", _hoisted_22, [_createTextVNode("总战绩 "), _createElementVNode("b", _hoisted_23, _toDisplayString(wbsjStatsHome.value.sWinGoalMatchCnt) + "胜", 1), _createElementVNode("b", _hoisted_24, _toDisplayString(wbsjStatsHome.value.sDrawMatchCnt) + "平", 1), _createElementVNode("b", _hoisted_25, _toDisplayString(wbsjStatsHome.value.sLossGoalMatchCnt) + "负", 1)]), _createElementVNode("div", _hoisted_26, [_createTextVNode("主场 "), _createElementVNode("b", null, _toDisplayString(wbsjStatsHome.value.sHomeWinGoalMatchCnt) + "胜 " + _toDisplayString(wbsjStatsHome.value.sHomeDrawMatchCnt) + "平 " + _toDisplayString(wbsjStatsHome.value.sHomeLossGoalMatchCnt) + "负", 1)])]), _hoisted_27, _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(matchHead.value.awayTeamShortName || '客队'), 1), _createElementVNode("div", _hoisted_30, [_createTextVNode("排名 "), _createElementVNode("b", null, _toDisplayString(wbsjStatsAway.value.ranking || '-'), 1)]), _createElementVNode("div", _hoisted_31, [_createTextVNode("总战绩 "), _createElementVNode("b", _hoisted_32, _toDisplayString(wbsjStatsAway.value.sWinGoalMatchCnt) + "胜", 1), _createElementVNode("b", _hoisted_33, _toDisplayString(wbsjStatsAway.value.sDrawMatchCnt) + "平", 1), _createElementVNode("b", _hoisted_34, _toDisplayString(wbsjStatsAway.value.sLossGoalMatchCnt) + "负", 1)]), _createElementVNode("div", _hoisted_35, [_createTextVNode("客场 "), _createElementVNode("b", null, _toDisplayString(wbsjStatsAway.value.sHomeWinGoalMatchCnt) + "胜 " + _toDisplayString(wbsjStatsAway.value.sHomeDrawMatchCnt) + "平 " + _toDisplayString(wbsjStatsAway.value.sHomeLossGoalMatchCnt) + "负", 1)])])])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", {
        class: _normalizeClass(["seg-item", {
          active: activeTab.value === 0
        }]),
        onClick: _cache[0] || (_cache[0] = $event => switchTab(0))
      }, "历史交锋", 2), _createElementVNode("div", {
        class: _normalizeClass(["seg-item", {
          active: activeTab.value === 1
        }]),
        onClick: _cache[1] || (_cache[1] = $event => switchTab(1))
      }, "主队近况", 2), _createElementVNode("div", {
        class: _normalizeClass(["seg-item", {
          active: activeTab.value === 2
        }]),
        onClick: _cache[2] || (_cache[2] = $event => switchTab(2))
      }, "客队近况", 2)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(TERM_OPTIONS, n => {
        return _createElementVNode("div", {
          class: _normalizeClass(["seg-item", {
            active: termLimits.value === n
          }]),
          key: n,
          onClick: $event => switchTerm(n)
        }, "近" + _toDisplayString(n) + "场", 11, _hoisted_40);
      }), 64))])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
        class: _normalizeClass(["seg-item", {
          active: homeAwayFlag.value === 0
        }]),
        onClick: _cache[3] || (_cache[3] = $event => switchHomeAway(0))
      }, "不区分主客", 2), _createElementVNode("div", {
        class: _normalizeClass(["seg-item", {
          active: homeAwayFlag.value === 1
        }]),
        onClick: _cache[4] || (_cache[4] = $event => switchHomeAway(1))
      }, "主客同场", 2)]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", {
        class: _normalizeClass(["seg-item", {
          active: tournamentFlag.value === 0
        }]),
        onClick: _cache[5] || (_cache[5] = $event => switchTournament(0))
      }, "全部赛制", 2), _createElementVNode("div", {
        class: _normalizeClass(["seg-item", {
          active: tournamentFlag.value === 1
        }]),
        onClick: _cache[6] || (_cache[6] = $event => switchTournament(1))
      }, "相同赛制", 2)])])]), _createVNode(_component_var_loading, {
        loading: loading.value,
        description: "加载中"
      }, {
        default: _withCtx(() => [errorMsg.value ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createTextVNode(_toDisplayString(errorMsg.value) + " ", 1), _createElementVNode("span", {
          class: "mr-retry",
          onClick: reloadAll
        }, "重试")])) : _createCommentVNode("", true), activeTab.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createTextVNode("🔄 历史交锋"), _createElementVNode("span", _hoisted_47, _toDisplayString(historyStatistics.value.teamShortName ? historyStatistics.value.teamShortName + ' 视角' : ''), 1)]), historyStatistics.value.totalLegCnt ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("span", _hoisted_50, "近" + _toDisplayString(historyStatistics.value.totalLegCnt) + "场", 1), _createElementVNode("span", _hoisted_51, _toDisplayString(historyStatistics.value.winGoalMatchCnt) + "胜", 1), _createElementVNode("span", _hoisted_52, _toDisplayString(historyStatistics.value.drawMatchCnt) + "平", 1), _createElementVNode("span", _hoisted_53, _toDisplayString(historyStatistics.value.lossGoalMatchCnt) + "负", 1)]), _createElementVNode("div", _hoisted_54, [_createElementVNode("i", {
          class: "bar-w",
          style: _normalizeStyle({
            width: wdlStyle(historyStatistics.value).w + '%'
          })
        }, null, 4), _createElementVNode("i", {
          class: "bar-d",
          style: _normalizeStyle({
            width: wdlStyle(historyStatistics.value).d + '%'
          })
        }, null, 4), _createElementVNode("i", {
          class: "bar-l",
          style: _normalizeStyle({
            width: wdlStyle(historyStatistics.value).l + '%'
          })
        }, null, 4)])])) : _createCommentVNode("", true), historyMatchList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_55, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyMatchList.value, (m, i) => {
          return _openBlock(), _createElementBlock("div", {
            class: "mr-item",
            key: i
          }, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString(m.matchDate), 1), _createElementVNode("div", _hoisted_58, _toDisplayString(m.tournamentShortName), 1)]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", {
            class: _normalizeClass(["mr-item-team", {
              view: isViewHome(m, historyStatistics.value.teamShortName)
            }])
          }, _toDisplayString(m.homeTeamShortName), 3), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-score", 'score-' + outcomeOf(m, historyStatistics.value.teamShortName)])
          }, _toDisplayString(m.fullCourtGoal), 3), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-team", {
              view: !isViewHome(m, historyStatistics.value.teamShortName)
            }])
          }, _toDisplayString(m.awayTeamShortName), 3)]), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-tag", 'tag-' + outcomeOf(m, historyStatistics.value.teamShortName)])
          }, _toDisplayString(outcomeText(m, historyStatistics.value.teamShortName)), 3)]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_60, "暂无交锋记录"))])) : activeTab.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createTextVNode("🔥 " + _toDisplayString(matchHead.value.homeTeamShortName || '主队') + "近况", 1), _createElementVNode("span", _hoisted_63, "最近 " + _toDisplayString(homeFormStats.value.totalLegCnt || termLimits.value) + " 场", 1)]), homeFormStats.value.totalLegCnt ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("span", _hoisted_66, "近" + _toDisplayString(homeFormStats.value.totalLegCnt) + "场", 1), _createElementVNode("span", _hoisted_67, _toDisplayString(homeFormStats.value.winGoalMatchCnt) + "胜", 1), _createElementVNode("span", _hoisted_68, _toDisplayString(homeFormStats.value.drawMatchCnt) + "平", 1), _createElementVNode("span", _hoisted_69, _toDisplayString(homeFormStats.value.lossGoalMatchCnt) + "负", 1)]), _createElementVNode("div", _hoisted_70, [_createElementVNode("i", {
          class: "bar-w",
          style: _normalizeStyle({
            width: wdlStyle(homeFormStats.value).w + '%'
          })
        }, null, 4), _createElementVNode("i", {
          class: "bar-d",
          style: _normalizeStyle({
            width: wdlStyle(homeFormStats.value).d + '%'
          })
        }, null, 4), _createElementVNode("i", {
          class: "bar-l",
          style: _normalizeStyle({
            width: wdlStyle(homeFormStats.value).l + '%'
          })
        }, null, 4)])])) : _createCommentVNode("", true), homeFormList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_71, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeFormList.value, (m, i) => {
          return _openBlock(), _createElementBlock("div", {
            class: "mr-item",
            key: i
          }, [_createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, _toDisplayString(m.matchDate), 1), _createElementVNode("div", _hoisted_74, _toDisplayString(m.tournamentShortName), 1)]), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", {
            class: _normalizeClass(["mr-item-team", {
              view: isViewHome(m, homeFormStats.value.teamShortName)
            }])
          }, _toDisplayString(m.homeTeamShortName), 3), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-score", 'score-' + outcomeOf(m, homeFormStats.value.teamShortName)])
          }, _toDisplayString(m.fullCourtGoal), 3), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-team", {
              view: !isViewHome(m, homeFormStats.value.teamShortName)
            }])
          }, _toDisplayString(m.awayTeamShortName), 3)]), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-tag", 'tag-' + outcomeOf(m, homeFormStats.value.teamShortName)])
          }, _toDisplayString(outcomeText(m, homeFormStats.value.teamShortName)), 3)]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_76, "暂无数据"))])) : (_openBlock(), _createElementBlock("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createTextVNode("🔥 " + _toDisplayString(matchHead.value.awayTeamShortName || '客队') + "近况", 1), _createElementVNode("span", _hoisted_79, "最近 " + _toDisplayString(awayFormStats.value.totalLegCnt || termLimits.value) + " 场", 1)]), awayFormStats.value.totalLegCnt ? (_openBlock(), _createElementBlock("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("span", _hoisted_82, "近" + _toDisplayString(awayFormStats.value.totalLegCnt) + "场", 1), _createElementVNode("span", _hoisted_83, _toDisplayString(awayFormStats.value.winGoalMatchCnt) + "胜", 1), _createElementVNode("span", _hoisted_84, _toDisplayString(awayFormStats.value.drawMatchCnt) + "平", 1), _createElementVNode("span", _hoisted_85, _toDisplayString(awayFormStats.value.lossGoalMatchCnt) + "负", 1)]), _createElementVNode("div", _hoisted_86, [_createElementVNode("i", {
          class: "bar-w",
          style: _normalizeStyle({
            width: wdlStyle(awayFormStats.value).w + '%'
          })
        }, null, 4), _createElementVNode("i", {
          class: "bar-d",
          style: _normalizeStyle({
            width: wdlStyle(awayFormStats.value).d + '%'
          })
        }, null, 4), _createElementVNode("i", {
          class: "bar-l",
          style: _normalizeStyle({
            width: wdlStyle(awayFormStats.value).l + '%'
          })
        }, null, 4)])])) : _createCommentVNode("", true), awayFormList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_87, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(awayFormList.value, (m, i) => {
          return _openBlock(), _createElementBlock("div", {
            class: "mr-item",
            key: i
          }, [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, _toDisplayString(m.matchDate), 1), _createElementVNode("div", _hoisted_90, _toDisplayString(m.tournamentShortName), 1)]), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", {
            class: _normalizeClass(["mr-item-team", {
              view: isViewHome(m, awayFormStats.value.teamShortName)
            }])
          }, _toDisplayString(m.homeTeamShortName), 3), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-score", 'score-' + outcomeOf(m, awayFormStats.value.teamShortName)])
          }, _toDisplayString(m.fullCourtGoal), 3), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-team", {
              view: !isViewHome(m, awayFormStats.value.teamShortName)
            }])
          }, _toDisplayString(m.awayTeamShortName), 3)]), _createElementVNode("div", {
            class: _normalizeClass(["mr-item-tag", 'tag-' + outcomeOf(m, awayFormStats.value.teamShortName)])
          }, _toDisplayString(outcomeText(m, awayFormStats.value.teamShortName)), 3)]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_92, "暂无数据"))]))]),
        _: 1
      }, 8, ["loading"])]);
    };
  }
};